import uuid from 'uuid'
let lifePremium = {
  data () {
    return {
      // 1rOIShcOJS5dCozLjS_9_NzS-ANlFyVkWHP_QnuFDOVk 최초 스프레드시트 버전

      spreadsheetUrl: null, //'1rOIShcOJS5dCozLjS_9_NzS-ANlFyVkWHP_QnuFDOVk',
      spreadsheetUrlList: [
        /*{
          label: '기본 보험료 테이블',
          value: '1rOIShcOJS5dCozLjS_9_NzS-ANlFyVkWHP_QnuFDOVk'
        },
        {
          label: '기본 보험료 테이블2',
          value: '1rOIShcOJS5dCozLjS_9_NzS-ANlFyVkWHP_QnuFDOVk_2'
        }*/
      ]
    }
  },
  async created() {
    await this.getlifePremiumList()
  },
  methods: {
    async getlifePremiumList() {
      var params = {
        page : 1,
        size : 100,
      }
      await this.axios.get("https://dev-api2.insunetfc.com/v1/crm/life.premium.table", {
        params : params
      }).then(res => {
        let { data, error } = res.data
        if (error) {
          return
        }
        this.spreadsheetUrlList = data.items.map(e => {
          return {
            label: e.is_default ? ('[기본] ' + e.name) : e.name,
            value: e.spread_sheet_key
          }
        })
        let defaultItem = data.items.find(e => e.is_default)
        if(defaultItem) {
          //this.spreadsheetUrl = defaultItem.spread_sheet_key
        }
        
      })
    },
    changeSpreadSheet(url) {
      this.spreadsheetUrl = url
    },
    promiseJSONP(sheet, query, callbackId) {
      return new Promise((resolve, reject) => {
        let script = window.document.createElement('script');
        script.async = true
        script.src = `https://docs.google.com/spreadsheets/d/${this.spreadsheetUrl}/gviz/tq?tq=${query}&tqx=responseHandler:cb_${callbackId}&sheet=${sheet}`
        script.onerror = function () {
          reject()
        }
        let done = false
        script.onload = script.onreadystatechange = function () {
          if (!done && (!this.readyState || this.readyState === 'loaded' || this.readyState ===
            'complete')) {
            done = true;
            script.onload = script.onreadystatechange = null;
            if (script.parentNode) {
              script.parentNode.removeChild(script)
              
            }
          }
        }
        window.document.getElementsByTagName('head')[0].appendChild(script)
        let cbFuncname = `cb_${callbackId}`
        window[cbFuncname] = function(data) {
          resolve(data)
        }
      })
    },
    async getSpreadSheets() {
      let query = encodeURI(`SELECT A OFFSET 1`)
      let data = await this.promiseJSONP('정보', query, uuid().replace(/-/g, ""))
      console.log('getSpreadSheets', data)
      if(data.status == 'ok') {
        let rows = data.table.rows
        rows.forEach(e => {
          let rData = e.c
          this.lifeEstimateCompare.시트.push(rData[0] ? rData[0].v : null)
        })
      }
    },
    async getSpreadInsuranceInfo(보험종목) {
      let query = encodeURI(`SELECT * WHERE A = '${보험종목}'`)
      let data = await this.promiseJSONP('보험정보', query, uuid().replace(/-/g, ""))
      console.log('getSpreadInsuranceInfo', data)
      if(data.status == 'ok') {
        let rows = data.table.rows
        rows.forEach(e => {
          let rData = e.c
          rData.forEach((comp, idx) => {
            if(comp && comp.v && idx > 0) this.lifeEstimateCompare.보험정보.push(comp.v)
          })
        })
      }
    },
    async getSpreadInsuranceDetailInfo(보험종목) {
      let query = encodeURI(`SELECT * WHERE A = '${this.firstKey}'`)
      let data = await this.promiseJSONP('항목정보', query, uuid().replace(/-/g, ""))
      console.log('getSpreadInsuranceDetailInfo', data)
      if(data.status == 'ok') {
        let rows = data.table.rows
        rows.forEach(e => {
          let rData = e.c
          let _struc = {
            보험종목: rData[0] ? rData[0].v : null,
            항목명: rData[1] ? rData[1].v : null,
            사용: rData[2] ? rData[2].v : null,
            보장항목: rData[3] ? rData[3].v : null,
            설명: rData[4] ? rData[4].v : null,
          }
          this.lifeEstimateCompare.항목정보.push(_struc)
        })
      }
    },
    async getSpreadCompanyInfo(보험사) {
      let query = encodeURI(`SELECT B WHERE A = '이미지'`)
      let data = await this.promiseJSONP(보험사, query, uuid().replace(/-/g, ""))
      console.log('getSpreadCompanyInfo', data)
      if(data.status == 'ok') {
        let rows = data.table.rows
        this.lifeEstimateCompare.보험사정보 = Object.assign({}, this.lifeEstimateCompare.보험사정보, {[보험사]: null})
        rows.forEach(e => {
          let rData = e.c
          let _struc = {
            이미지: rData[0] ? rData[0].v : null,
          }
          this.lifeEstimateCompare.보험사정보[보험사] = _struc
        })
        
      }
    },
    async getSpreadCompCategoryDetailInfo(보험종목, 보험사, 성별, 등급) {
      let query = encodeURI(`SELECT * WHERE A = '${보험종목}' AND B = '${성별}' AND C = '${등급}'`)
      let data = await this.promiseJSONP(보험사, query, uuid().replace(/-/g, ""))
      console.log('getSpreadCompCategoryDetailInfo', data)
      if(data.status == 'ok') {
        let rows = data.table.rows
        window.rows = rows;
        this.lifeEstimateCompare.보험사항목정보 = Object.assign({}, this.lifeEstimateCompare.보험사항목정보, { [보험사]: {} })
        rows.forEach((e, i) => {
          let rData = e.c
          let _struc = {
            보험종목: rData[0] ? rData[0].v : null,
            성별: rData[1] ? rData[1].v : null,
            등급: rData[2] ? rData[2].v : null,
            항목명: rData[3] ? rData[3].v : null,
            데이터1: rData[4] ? rData[4].v : null,
            데이터2: rData[5] ? rData[5].v : null,
            데이터3: rData[6] ? rData[6].v : null,
            데이터4: rData[7] ? rData[7].v : null,
            데이터5: rData[8] ? rData[8].v : null,
            기준보험금: rData[7] ? rData[7].v : null,
            isCalc: false
          }

          if (i === 0) {
            this.firstKey = _struc.보험종목;
          }

          if (!this.lifeEstimateCompare.보험사항목정보[보험사][_struc.보험종목]) {
            this.lifeEstimateCompare.보험사항목정보[보험사][_struc.보험종목] = Object.assign({}, this.lifeEstimateCompare.보험사항목정보[보험사][_struc.보험종목], { [_struc.항목명]: {} });
          }
          this.lifeEstimateCompare.보험사항목정보[보험사][_struc.보험종목][_struc.항목명] = _struc
        })
      }
    },
    async getSpreadCompInsurancePri(보험종목, 보험사, 성별, 등급, 나이) {
      let colLetter = this.columnToLetter(나이 * 1 + 7)
      let query = encodeURI(`SELECT A, B, C, D, E, F, ${colLetter} WHERE A = '${보험종목}' AND B = '${성별}' AND C = '${등급}'`)
      let data = await this.promiseJSONP(`${보험사}-보험료`, query, uuid().replace(/-/g, ""))
      console.log('getSpreadCompInsurancePri', data)
      if(data.status == 'ok') {
        let rows = data.table.rows
        this.lifeEstimateCompare.보험사보험료 = Object.assign({}, this.lifeEstimateCompare.보험사보험료, {[보험사]: {}})
        rows.forEach(e => {
          let rData = e.c
          let _struc = {
            보험종목: rData[0] ? rData[0].v : null,
            성별: rData[1] ? rData[1].v : null,
            등급: rData[2] ? rData[2].v : null,
            항목명: rData[3] ? rData[3].v : null,
            보험사항목명: rData[4] ? rData[4].v : null,
            보험료기준: rData[5] ? rData[5].v : null,
            데이터1: rData[6] ? rData[6].v : null,
            기준보험료: rData[6] ? rData[6].v : null,
          }

          this.lifeEstimateCompare.보험사보험료[보험사][_struc.항목명] = _struc
          this.calcInsurancePri(보험사, _struc.항목명)
        })
        this.createExtraInsurancePriItem(보험종목, 보험사, 성별, 등급)
        this.calcExtraInsurancePri(보험사)
      }
    },
    columnToLetter(column) {
      var temp, letter = '';
      while (column > 0)
      {
        temp = (column - 1) % 26;
        letter = String.fromCharCode(temp + 65) + letter;
        column = (column - temp - 1) / 26;
      }
      return letter;
    },
  }
}
export default lifePremium;